// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1172":"afd10286","3179":"b3d54d39","6016":"588d52d8"}[chunkId] + ".chunk.css";
};